import { Search, X } from "lucide-react"
import type { ClientTheme } from "@/app/lib/themes"
import { controlBase, onFocus, onBlur } from "@/app/lib/tableStyles"

interface SearchInputProps {
  value: string
  onChange: (v: string) => void
  placeholder: string
  width?: string
  theme: ClientTheme
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  width = "220px",
  theme,
}: SearchInputProps) {
  const ctrlBase = controlBase(theme)
  return (
    <div className="relative flex-shrink-0" style={{ width }}>
      <Search
        size={13}
        style={{
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: theme.textDim,
          pointerEvents: "none",
        }}
      />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          ...ctrlBase,
          width: "100%",
          paddingLeft: "30px",
          paddingRight: value ? "28px" : "10px",
        }}
        onFocus={onFocus(theme)}
        onBlur={onBlur(theme)}
      />
      {value && (
        <button
          onClick={() => onChange("")}
          style={{
            position: "absolute",
            right: "8px",
            top: "50%",
            transform: "translateY(-50%)",
            color: theme.textDim,
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
          }}
        >
          <X size={12} />
        </button>
      )}
    </div>
  )
}
